// custom typefaces

import "./src/styles/global.css"
import "prismjs/themes/prism-okaidia.css"
import "prismjs/plugins/command-line/prism-command-line.css"

//export {  wrapRootElement } from "./src/store/reduxWrapper.js"
